"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _paymentSettings = require("@/api/appBasicSetup/paymentSettings");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CopyrightMessage',
  data: function data() {
    return {
      itemKey: 'APP_Copyright_Message',
      form: {
        alipayAppId: '',
        rootCertContent: '',
        publicKey: '',
        privateKey: ''
        // alipayPublicCertContent: '',
        // certContent: ''
      },
      rules: {
        // alipayAppId: [
        //   { required: true, message: '请输入支付宝APPID', trigger: 'blur' }
        // ],
        // rootCertContent: [
        //   { required: true, message: '请输入支付宝根证书', trigger: 'blur' }
        // ],
        // publicKey: [
        //   { required: true, message: '请输入支付宝公钥', trigger: 'blur' }
        // ],
        // privateKey: [
        //   { required: true, message: '请输入支付宝私钥', trigger: 'blur' }
        // ],
        // alipayPublicCertContent: [
        //   { required: true, message: '请输入支付宝公钥证书', trigger: 'blur' }
        // ],
        // certContent: [
        //   { required: true, message: '请输入应用公钥证书', trigger: 'blur' }
        // ]
      }
    };
  },
  created: function created() {
    this.queryAlipayAccountNumber();
  },
  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.$confirm('是否保存此设置？', '提示', {
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(function () {
            _this.editAlipayAccountNumber();
          });
        } else {
          _this.$message.error('请填写所有必填项');
          return false;
        }
      });
    },
    handleReset: function handleReset() {
      this.$refs.form.resetFields();
    },
    queryAlipayAccountNumber: function () {
      var _queryAlipayAccountNumber2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {};
              _context.n = 1;
              return (0, _paymentSettings.queryAlipayAccountNumber)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.form.alipayAppId = res.data.alipayAppId;
                this.form.rootCertContent = res.data.rootCertContent || '';
                // this.form.alipayPublicCertContent = res.data.alipayPublicCertContent
                // this.form.certContent = res.data.certContent
                this.form.publicKey = res.data.publicKey;
                this.form.privateKey = res.data.privateKey;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function queryAlipayAccountNumber() {
        return _queryAlipayAccountNumber2.apply(this, arguments);
      }
      return queryAlipayAccountNumber;
    }(),
    editAlipayAccountNumber: function () {
      var _editAlipayAccountNumber2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, response, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.form);
              _context2.n = 1;
              return (0, _paymentSettings.editAlipayAccountNumber)(params);
            case 1:
              response = _context2.v;
              if (response.code === 0) {
                this.$message.success('保存成功');
                this.queryAlipayAccountNumber();
              } else {
                this.$message.error(response.msg || '保存失败');
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.$message.error('保存失败');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function editAlipayAccountNumber() {
        return _editAlipayAccountNumber2.apply(this, arguments);
      }
      return editAlipayAccountNumber;
    }()
  }
};